package app.smartcoding.realrate.domain.model.creditCardField

import androidx.compose.ui.text.input.TextFieldValue

sealed interface LoanField : Field {
    data class ReceivedAmount(override val textFieldValue: TextFieldValue, override val delta: Double) : LoanField
    data class RequestedAmount(override val textFieldValue: TextFieldValue, override val delta: Double) : LoanField
    data class TaxFee(override val textFieldValue: TextFieldValue, override val delta: Double) : LoanField
    data class TaxRate(override val textFieldValue: TextFieldValue, override val delta: Double) : LoanField
}